import {VariantConfigT} from '@/lib/types/colors.types';

export const yellowConfig: VariantConfigT = {
  basic: {
    icon: 'yellow',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'yellow',
    active: 'yellow',
  },
  outline: {
    icon: 'yellow',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'yellow',
    iconHover: 'yellow',
    iconActive: 'yellow',
    hover: 'yellow',
    active: 'yellow',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
